import { TableColumnType } from 'antd';

import { useDefaultSortOrder } from './use-default-sort-order';

/**
 * A utility function that provides a sorting mechanism for table columns.
 *
 * This function applies default sorting order to columns that have a `sorter`
 * property and a `dataIndex`. It utilizes a custom hook, `useDefaultSortOrder`,
 * to retrieve the default sort order value based on the `dataIndex` of the column.
 *
 * @template T - The type of the table row data.
 * @returns {function(TableColumnType<T>[]): TableColumnType<T>[]} - A function that accepts an array of
 * table columns and returns an updated array where applicable columns have the `defaultSortOrder` set.
 */

export const useTableSortColumns = <T>(): ((
    columns: TableColumnType<T>[]
) => TableColumnType<T>[]) => {
    const getSortOrder = useDefaultSortOrder();

    return (columns) =>
        columns.map((column) => {
            if (column.sorter && column.dataIndex) {
                return {
                    ...column,
                    defaultSortOrder: getSortOrder(column.dataIndex.toString()),
                };
            } else {
                return column;
            }
        });
};
